import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

export default function Nav() {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  const links = [
    { label: "About", href: "/#about" },
    { label: "Previous Acquisitions", href: "/#results" },
    { label: "Testimonials", href: "/#testimonials" },
    { label: "Services", href: "/#services" },
    { label: "Cairns Home Buyers", href: "/#home-buyers" },
    { label: "Calculator", href: "/#calculator" },
    { label: "Free eBook", href: "/#ebook" },
    { label: "Contact", href: "/#contact" }
  ];

  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 left-0 right-0 z-50 bg-[#0A100D] border-b border-neutral-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
          <img src="/logos/iscout-mark.svg" alt="iScout Property" className="h-8 w-8 md:h-9 md:w-9" />
          <span className="font-serif-display text-xl md:text-2xl tracking-wide leading-none">
            <span className="text-[#36C281]">iScout</span> Property
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-neutral-300 hover:text-[#36C281] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="/#contact"
          data-testid="nav-cta-btn"
          className="hidden md:inline-flex btn-primary"
          style={{ padding: "12px 20px", fontSize: 12 }}
        >
          Book a Call
        </a>

        <button
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#EFE9D4]"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-neutral-800 bg-[#0A100D]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={closeMenu}
                data-testid={`mobile-link-${l.label.toLowerCase()}`}
                className="text-base text-neutral-300 hover:text-[#36C281] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
